import { CREDENTIAL_LABEL_SOURCE_MANUAL } from '@shared/schema/credentialLabelSource.js';
import { getConnections } from '@/redux/requests/connectionsRequests.js';
import upsertCompanyCredential from '@/redux/requests/credentials/upsertCompanyCredential.js';

/**
 * Renames a connection. Only the name changes: no secrets are sent, so the saved values and the
 * connection's status stay as they are. The label source is manual, or the server keeps the old name.
 */
const renameConnection = ({ connection, label }) => {
  return async () => {
    const renameRes = await upsertCompanyCredential({
      appId: connection.appId,
      credentialId: connection.credentialId,
      meta: { ...(connection.meta || {}), label: String(label || '').trim(), labelSource: CREDENTIAL_LABEL_SOURCE_MANUAL },
      source: 'pieve-web-rename'
    });

    if (renameRes?.success !== false) {
      await getConnections();
    }

    return renameRes;
  };
};

export default renameConnection;
